import { hideStory, type HideInput } from '../repositories/readerFeedbackRepository';
import { saveBetaSearch } from '../repositories/betaSearchRepository';
import { localPreferencesAccountId } from './localReaderPreferences';
import { readerEvent } from './readerTelemetry';
export type PendingReaderAction = { kind: 'hide'; input: HideInput } |
  { kind: 'save_feed'; description: string; showInHome: boolean };
const key = 'reader_pending_action';
/** The feedback id of a hide replayed after sign-in; the story list reopens its reason prompt. */
export const RESUMED_HIDE_KEY = 'reader_resumed_hide';
export function rememberReaderAction(action: PendingReaderAction) { sessionStorage.setItem(key, JSON.stringify(action)); }
export function hasReaderAction(userId: string): boolean {
  const raw = sessionStorage.getItem(key);
  if (!raw) return false;
  const action = JSON.parse(raw);
  return !action.userId || action.userId === userId;
}
export function clearReaderAction() { sessionStorage.removeItem(key); }
export async function resumeReaderAction() {
  const raw = sessionStorage.getItem(key);
  if (!raw) return;
  const action = JSON.parse(raw) as PendingReaderAction & { userId?: string };
  const userId = localPreferencesAccountId();
  if (!userId || (action.userId && action.userId !== userId)) return;
  const bound = JSON.stringify({ ...action, userId });
  sessionStorage.setItem(key, bound);
  if (action.kind === 'hide') {
    await hideStory(action.input);
    readerEvent('story_hide', { ...action.input.properties, story_id: action.input.story_id, feedback_id: action.input.id, surface: action.input.surface });
    sessionStorage.setItem(RESUMED_HIDE_KEY, action.input.id);
  } else {
    const saved = await saveBetaSearch(action.description, undefined, action.showInHome);
    readerEvent('feed_add', { search_id: saved.id, method: 'save_new_button', action: 'create', show_in_home: action.showInHome });
    sessionStorage.setItem('reader_resumed_save', saved.id);
  }
  if (sessionStorage.getItem(key) === bound) clearReaderAction();
}
